import React from 'react';

import styled from '@emotion/styled';

import BookmarkExistIcon from '../../components/Icons/BookmarkExistIcon';
import useRemoveBookmarkJob from '../../hooks/dashboard/jobs/useRemoveBookmarkJob';
import { LoadingOutlined } from '@ant-design/icons';

interface BookmarkJobProps {
  jobId: string;
}
const CancelBookmarkJob: React.FC<BookmarkJobProps> = ({ jobId }) => {
  const { removeBookmarkJob, loading } = useRemoveBookmarkJob();

  const handleClick = (e: any) => {
    e.stopPropagation();
    removeBookmarkJob(jobId);
  };

  return (
    <Container>
      {loading ? (
        <LoadingOutlined />
      ) : (
        <IconCell onClick={handleClick}>
          <BookmarkExistIcon />
        </IconCell>
      )}
    </Container>
  );
};

export default CancelBookmarkJob;

const Container = styled.div`
  display: flex;
  cursor: pointer;
`;

const IconCell = styled.div`
  display: grid;
  place-content: center;
  width: 32px;
  height: 32px;
`;
